module.exports = __webpack_public_path__ + "@/assets/img/005-girl-2.cecd24f8.svg";